<template>
  <div class="cart-button">
    <div class="cart-button__cart">
      <section :mg-stat-lob="`goods_id=${goodsId}`"
               mg-stat-click
               mg-stat-custom="cont=联系客服&label=btn&direct=web&addr=haowu_gotoService"
               @click="gotoService">
        <i class="icon service"></i>
        <div class="cart-button__cart-title">联系客服</div>
      </section>
      <section :mg-stat-lob="`goods_id=${goodsId}`"
               mg-stat-click mg-stat-custom="cont=购物车&label=btn&direct=web&addr=haowu_cart"
               @click="gotoCart">
        <i class="icon cart"></i>
        <div class="cart-button__cart-title">购物车</div>
        <span class="cart-button__cart-num">{{ cartNum }}</span>
      </section>
    </div>
    <div v-show="!isPreSell" :mg-stat-lob="`goods_id=${goodsId}&goods_num=${nowGoodsNum}`" class="cart-button__add"
         mg-stat-click mg-stat-custom="cont=加入购物车&label=btn&direct=cntp&addr=w_sku"
         @click="addCart('addCart')">加入购物车
    </div>
    <div v-show="!isPreSell" :mg-stat-lob="`goods_id=${goodsId}&goods_num=${nowGoodsNum}`" class="cart-button__buy"
         mg-stat-click mg-stat-custom="cont=立即购买&label=btn&direct=cntp&addr=w_sku"
         @click="addCart('buyNow')">立即购买
    </div>
    <div v-show="isPreSell" :mg-stat-lob="`goods_id=${goodsId}&goods_num=${nowGoodsNum}`" class="cart-button__presell"
         mg-stat-click mg-stat-custom="cont=立即付定金&label=btn&direct=cntp&addr=w_sku"
         @click="addCart('preSell')">
      <div>{{ preEndTime }} 定金期结束</div>
      <div>
        <p>立即付定金</p>
        <p>￥{{ preSellInfo.deposit }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { beforeRouteChange } from 'utils/uploadData';
import { dateFormater } from 'utils/date';
import Env from 'utils/env';


export default {
  props: ['isMultiple', 'originPage', 'isPreSell', 'preSellInfo', 'goodsId', 'nowGoodsNum'],
  data() {
    return {
      endTime: {
        days: 0,
        hours: '00',
        minutes: '00',
      },
    };
  },
  computed: {
    ...mapState('goods', ['cartData']),
    preEndTime() {
      const { preSellInfo: { retainageStart } } = this;
      return dateFormater(retainageStart * 1000, 'MM-dd hh:mm');
    },
    cartNum() {
      const { cartData } = this;
      if (Array.isArray(cartData)) {
        return cartData.length;
      }
      return 0;
    },
  },
  created() {
    this.getCartData();
  },
  methods: {
    ...mapActions('goods', ['fetchCartData']),
    gotoService() {
      window.location.href = `https://support.mgtv.com/webchat/chat.html?c=1&jId=3&pageName=shopByHaowu&goodsId=${this.goodsId}`;
    },
    gotoCart() {
      if (Env.isPc) {
        return;
      }
      beforeRouteChange({ path: '/cart' }, this.originPage);
    },
    async getCartData() {
      await this.fetchCartData();
    },
    addCart(type) {
      this.$emit('change', type);
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-button {
  @media screen and (min-width: 1025px) {
    width: 500px; /*no*/
    left: calc(50% - 250px); /*no*/
    right: calc(50% - 250px); /*no*/
  }
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background: #fff;
  color: #fff;
  z-index: 10;

  &__cart,
  &__add,
  &__buy {
    flex: 1;
    height: 110px;
    line-height: 110px;
    text-align: center;
    font-size: 30px;
  }

  &__cart {
    background: #fff;
    position: relative;
  }

  &__cart {
    display: flex;

    section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 50%;
      height: 100%;
      position: relative;

      div {
        line-height: 1;
        margin-top: 7px;
      }
    }

    &-title {
      font-size: 24px;
      color: #4A4A4A;
    }

    &-num {
      position: absolute;
      right: 27px;
      top: 13px;
      display: inline-block;
      text-align: center;
      font-size: 19px;
      color: #fff;
      background: #ff8315;
      border-radius: 50%;
      width: 29px;
      height: 29px;
      line-height: 29px;
    }
  }

  &__add {
    color: #ff8315;
    background: #fff;
  }

  &__buy {
    color: #fff;
    background: #ff5f00;
  }

  &__presell {
    width: 524px;
    height: 82px;
    margin-right: 10px;
    background: linear-gradient(
            90deg,
            rgba(245, 77, 77, 1) 0%,
            rgba(255, 84, 0, 1) 100%
    );
    border-radius: 12px;
    padding: 8px 25px;
    display: flex;
    font-size: 20px;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: #fff;
    box-sizing: border-box;

    p {
      text-align: center;
      line-height: 1.2;
    }

    p:nth-of-type(1) {
      font-size: 28px;
    }
  }
}
</style>
